function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect, useRef } from 'react';
import useInViewport from '../../helpers/hooks/useInViewport';
var Img = function Img(_ref) {
  var _ref$id = _ref.id,
    pId = _ref$id === void 0 ? null : _ref$id,
    children = _ref.children,
    className = _ref.className,
    _onClick = _ref.onClick,
    src = _ref.src,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? '' : _ref$alt;
  var getInCache = function getInCache() {
    var image = new Image();
    image.src = src;
    return image.complete;
  };
  var ref = useRef();
  var _useState = useState(pId || uuid()),
    _useState2 = _slicedToArray(_useState, 1),
    id = _useState2[0];
  var _useState3 = useState(getInCache()),
    _useState4 = _slicedToArray(_useState3, 2),
    visible = _useState4[0],
    setVisible = _useState4[1];
  var _useState5 = useState(getInCache()),
    _useState6 = _slicedToArray(_useState5, 1),
    cache = _useState6[0];
  useInViewport({
    id: id,
    ref: ref,
    rootMargin: '100px 0px -100px 0px',
    onChange: function onChange(_ref2) {
      var intersecting = _ref2.intersecting;
      if (intersecting) setVisible(true);
    }
  });
  useEffect(function () {
    if (cache) $("#".concat(id, "-full")).css({
      opacity: 1
    });
  }, [cache]);
  useEffect(function () {
    if (!visible || !src) return;
    var blur = new window.Image();
    blur.onload = function () {
      $("#".concat(id, "-blur")).animate({
        opacity: 1
      }, 300);
      // $(`#${id}-blur`).css({ opacity: 1 });
    };
    blur.src = src.replace(/(\.[\w\d_-]+)$/i, '@blur$1');
    var img = new window.Image();
    img.onload = function () {
      $("#".concat(id, "-full")).animate({
        opacity: 1
      }, 300);
      // $(`#${id}-full`).css({ opacity: 1 });

      setTimeout(function () {
        return $("#".concat(id, "-blur")).animate({
          opacity: 1
        }, 300);
      }, 300);
      // setTimeout(() => $(`#${id}-blur`).css({ opacity: 0 }), 300);
    };
    img.src = src;
  }, [visible, src]);
  if (!src) return null;
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: 'img ' + className,
    style: style.parent || {},
    onClick: function onClick() {
      if (_onClick) _onClick();
    },
    ref: ref
  }, visible && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", {
    id: "".concat(id, "-blur"),
    src: src.replace(/(\.[\w\d_-]+)$/i, '@blur$1'),
    alt: alt,
    className: "img__blur"
  }), /*#__PURE__*/React.createElement("img", {
    id: "".concat(id, "-full"),
    src: src,
    alt: alt,
    className: "img__full"
  })), children);
};
export default Img;